import { useApp } from '../../app/context';
import { ru } from '../../i18n/ru';
import { inviteUrl } from '../../net/urls';
import { Button } from '../components/Button';
import { Dialog } from '../components/Dialog';
import { QrCode } from '../components/QrCode';
import { copyText } from '../dom';
import './InviteDialog.css';

/** QR code and link to the game, so a friend can join from their phone. */
export function InviteDialog({ onClose }: { onClose(): void }) {
  const app = useApp();
  const url = inviteUrl(window.location);
  const canShare = typeof navigator.share === 'function';

  const copy = async () => {
    const copied = await copyText(url);
    app.toasts.show(copied ? ru.invite.copied : ru.invite.copyFailed, {
      tone: copied ? 'success' : 'warning',
    });
  };

  const share = async () => {
    try {
      await navigator.share({ title: ru.appName, text: ru.invite.shareText, url });
    } catch {
      // The player closed the share sheet.
    }
  };

  return (
    <Dialog title={ru.invite.title} onClose={onClose}>
      <div class="invite">
        <QrCode text={url} label={ru.invite.qrLabel} class="invite__qr" />
        <div class="invite__info">
          <p class="invite__hint">{ru.invite.hint}</p>
          <p class="invite__url">{url}</p>
          <div class="invite__actions">
            <Button variant="yellow" icon="📋" onClick={() => void copy()}>
              {ru.invite.copy}
            </Button>
            {canShare && (
              <Button variant="blue" icon="📤" onClick={() => void share()}>
                {ru.invite.share}
              </Button>
            )}
          </div>
        </div>
      </div>
    </Dialog>
  );
}
